export function commonStatusPointCore() {
  const endpoint = '/vistaorder/commonStatusPoints';

  return {
      endpoint,
  };
}

export function commonStatusPointFilter() {
  const parameter = 'CommonStatusPoint';

  // Get rows
  const getRows = (data) => {
    const rows = [];

    data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
        value: row.filterValue,
        label: row.filterText,
      };
    });

    return rows;
  };

  return {
    parameter,
    getRows: getRows
  };
}
